export default __webpack_public_path__ + "img/0fe933dad116e661d4a7b0881f4a955b.jpg";